/*
 * @file Exports a function that shows if app version allows various actions
 */

import appVersion from './app_version'

// Difference between 1 and the greatest float > 1

var numberEpsilon: number = Number.EPSILON || Math.pow(2, -52)
// app version must be greater than the listed version otherwise
// can() should return false.

type AppAction =
  | 'chat'
  | 'newPostModal'
  | 'postMessage'
  | 'postNatively'
  | 'showAddPost'
  | 'showAlertSheet'
  | 'showChildPanel'
  | 'signalStatusWithLocation'
  | 'useNativeHeader'
  | 'useNativeCommentsPanel'
  | 'useNativeMapLocationPicker'
  | 'useNativeReactionDialog'

const ACTION_TO_VERSION_LIST: {
  [key in AppAction]: number
} = {
  chat: 44.1,
  newPostModal: 158.9,
  postMessage: 19.0,
  postNatively: 30.0,
  showAddPost: 19.0,
  showAlertSheet: 19.0,
  showChildPanel: 18.0,
  signalStatusWithLocation: 19.0,
  useNativeHeader: 59.1,
  useNativeCommentsPanel: 104.9,
  useNativeMapLocationPicker: 106.0,
  useNativeReactionDialog: 169.0,
}

export default function (action: AppAction): boolean {
  if (appVersion != null) {
    return appVersion - ACTION_TO_VERSION_LIST[action] > numberEpsilon
  }
  return false
}
